(() => {
    'use strict';

    function iniciarNavegacion() {
        const header = document.querySelector('.header');
        const boton = document.querySelector('.menu-movil');
        const navegacion = document.querySelector('#navegacion-principal');

        if (!header || !boton || !navegacion) return;

        const pantallaMovil = window.matchMedia('(max-width: 1199px)');
        const enlaces = navegacion.querySelectorAll('a');
        const pagina = window.location.pathname.split('/').pop() || 'index.php';

        enlaces.forEach((enlace) => {
            const destino = new URL(enlace.href).pathname.split('/').pop() || 'index.php';
            const activo = destino === pagina;
            enlace.classList.toggle('activo', activo);
            if (activo) enlace.setAttribute('aria-current', 'page');
            else enlace.removeAttribute('aria-current');
        });

        function cambiarMenu(abierto, devolverFoco = false) {
            header.classList.toggle('menu-abierto', abierto);
            boton.setAttribute('aria-expanded', String(abierto));
            boton.setAttribute('aria-label', abierto ? 'Cerrar menú' : 'Abrir menú');
            if (devolverFoco) boton.focus();
        }

        boton.addEventListener('click', () => {
            cambiarMenu(boton.getAttribute('aria-expanded') !== 'true');
        });

        enlaces.forEach((enlace) => enlace.addEventListener('click', () => cambiarMenu(false)));

        document.addEventListener('keydown', (evento) => {
            if (evento.key === 'Escape' && boton.getAttribute('aria-expanded') === 'true') {
                cambiarMenu(false, true);
            }
        });

        document.addEventListener('click', (evento) => {
            if (pantallaMovil.matches && !header.contains(evento.target)) cambiarMenu(false);
        });

        pantallaMovil.addEventListener('change', () => {
            // Al ocultar el panel, ningún enlace debe conservar el foco dentro.
            const focoEnPanel = navegacion.contains(document.activeElement);
            cambiarMenu(false, pantallaMovil.matches && focoEnPanel);
            if (!pantallaMovil.matches && document.activeElement === boton) {
                (navegacion.querySelector('[aria-current="page"]') || enlaces[0]).focus();
            }
        });

        cambiarMenu(false);
        // Si JavaScript no carga, CSS deja todos los enlaces visibles.
        header.classList.add('navegacion-lista');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', iniciarNavegacion, { once: true });
    } else {
        iniciarNavegacion();
    }
})();
